import type { MetaDaEquipe } from '../../vendas';

/**
 * Os textos do cartão "Meta da equipe" (1.0: balconista.js:2029). Só o agregado da equipe — o
 * cartão nunca diz quanto um colega fez. Conta o que o cheque conta: itens confirmados com o HOS.
 */
export interface TextoDaMetaDaEquipe {
  /** "Meta da equipe do mês" / "da semana" */
  readonly titulo: string;
  /** "150 de 200 itens" */
  readonly numeros: string;
  readonly chamada: string;
  /** null = a meta não tem brinde escrito. */
  readonly brinde: { readonly rotulo: string; readonly texto: string } | null;
}

const diaMes = (dia: string) => `${dia.slice(8, 10)}/${dia.slice(5, 7)}`;

export function textoDaMetaDaEquipe(m: MetaDaEquipe): TextoDaMetaDaEquipe {
  const item = (n: number) => (n === 1 ? 'item confirmado' : 'itens confirmados');
  return {
    titulo: `Meta da equipe ${m.periodo === 'mes' ? 'do mês' : 'da semana'}`,
    numeros: `${String(m.feitos)} de ${String(m.alvo)} ${m.alvo === 1 ? 'item' : 'itens'}`,
    chamada: m.batida
      ? 'A equipe bateu a meta!'
      : `Faltam ${String(m.faltam)} ${item(m.faltam)} da equipe até ${diaMes(m.ate)}. Soma de todos; vale o que bate com o cupom do HOS.`,
    brinde: m.brinde
      ? {
          rotulo: m.batida ? 'Brinde da equipe liberado' : 'Brinde da equipe se bater',
          texto: m.brinde,
        }
      : null,
  };
}
